import { Configuration, SapHealthControllerApi, TranslationControllerApi } from '@ringo/shared'
import { PropsWithChildren, createContext, useContext, useEffect } from 'react'
import {
    AlloyControllerApi,
    IamControllerApi,
    InfoControllerApi,
    MasterDataControllerApi,
    MetalAccountControllerApi,
    MetalPriceControllerApiControllerApi,
    PublicImageControllerApi,
    SettingsControllerApi,
    UserControllerApi,
    AddressControllerApi,
    ShippingDateControllerApi,
    FileControllerApi,
    PublicNewsletterControllerApi,
    UserCouponControllerApi,
    ShoppingCartControllerApi,
    FavoriteControllerApi,
    OrderControllerApi,
    CalculationControllerApi,
} from './api-helpers'
import { registerAxiosInterceptors } from './axios-interceptors'

interface IClientApi {
    metalPriceApi: MetalPriceControllerApiControllerApi
    userApi: UserControllerApi
    alloyApi: AlloyControllerApi
    iamApi: IamControllerApi
    masterDataApi: MasterDataControllerApi
    addressApi: AddressControllerApi
    orderApi: OrderControllerApi
    metalAccountApi: MetalAccountControllerApi
    infoApi: InfoControllerApi
    settingsApi: SettingsControllerApi
    publicImageApi: PublicImageControllerApi
    favoriteApi: FavoriteControllerApi
    calculationApi: CalculationControllerApi
    shoppingCartApi: ShoppingCartControllerApi
    shippingDateApi: ShippingDateControllerApi
    fileApi: FileControllerApi
    footerNewsletterApi: PublicNewsletterControllerApi
    couponControllerApi: UserCouponControllerApi
    translationApi: TranslationControllerApi
    sapHealthApi: SapHealthControllerApi
}

const ClientApiContext = createContext<IClientApi>({} as IClientApi)

interface Props {
    configuration: Configuration
}

export function ClientApiProvider({ configuration, children }: PropsWithChildren<Props>) {
    useEffect(() => {
        registerAxiosInterceptors()
    }, [])

    return (
        <ClientApiContext.Provider
            value={{
                metalPriceApi: new MetalPriceControllerApiControllerApi(configuration),
                userApi: new UserControllerApi(configuration),
                alloyApi: new AlloyControllerApi(configuration),
                iamApi: new IamControllerApi(configuration),
                masterDataApi: new MasterDataControllerApi(configuration),
                addressApi: new AddressControllerApi(configuration),
                orderApi: new OrderControllerApi(configuration),
                metalAccountApi: new MetalAccountControllerApi(configuration),
                infoApi: new InfoControllerApi(configuration),
                settingsApi: new SettingsControllerApi(configuration),
                publicImageApi: new PublicImageControllerApi(configuration),
                favoriteApi: new FavoriteControllerApi(configuration),
                calculationApi: new CalculationControllerApi(configuration),
                shoppingCartApi: new ShoppingCartControllerApi(configuration),
                shippingDateApi: new ShippingDateControllerApi(configuration),
                fileApi: new FileControllerApi(configuration),
                footerNewsletterApi: new PublicNewsletterControllerApi(configuration),
                couponControllerApi: new UserCouponControllerApi(configuration),
                translationApi: new TranslationControllerApi(configuration),
                sapHealthApi: new SapHealthControllerApi(configuration),
            }}
        >
            {children}
        </ClientApiContext.Provider>
    )
}
export const useMetalPriceApi = () => useContext(ClientApiContext).metalPriceApi
export const useUserApi = () => useContext(ClientApiContext).userApi
export const useAlloyApi = () => useContext(ClientApiContext).alloyApi
export const useIamApi = () => useContext(ClientApiContext).iamApi
export const useMasterDataApi = () => useContext(ClientApiContext).masterDataApi
export const useAddressApi = () => useContext(ClientApiContext).addressApi
export const useOrderApi = () => useContext(ClientApiContext).orderApi
export const useMetalAccountaApi = () => useContext(ClientApiContext).metalAccountApi
export const useInfoApi = () => useContext(ClientApiContext).infoApi
export const useSettingsApi = () => useContext(ClientApiContext).settingsApi
export const usePublicImageApi = () => useContext(ClientApiContext).publicImageApi
export const useFavoriteApi = () => useContext(ClientApiContext).favoriteApi
export const useCalculationApi = () => useContext(ClientApiContext).calculationApi
export const useShoppingCartApi = () => useContext(ClientApiContext).shoppingCartApi
export const useShippingDateApi = () => useContext(ClientApiContext).shippingDateApi
export const useFileApi = () => useContext(ClientApiContext).fileApi
export const useFooterNewsletterApi = () => useContext(ClientApiContext).footerNewsletterApi
export const useCouponControllerApi = () => useContext(ClientApiContext).couponControllerApi
export const useTranslationApi = () => useContext(ClientApiContext).translationApi
export const useSapHealthApi = () => useContext(ClientApiContext).sapHealthApi
